import { render, staticRenderFns } from "./ckeditor5.vue?vue&type=template&id=9efe650e"
import script from "./ckeditor5.vue?vue&type=script&lang=js"
export * from "./ckeditor5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports